import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Breadcrumbs } from '../../../components/Atom/breadcumbs';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import ShortenId from 'components/Atom/ShortenId';
import { TIMEZONES } from 'utils/constant';
import { formatInTimeZone } from 'date-fns-tz';
import { getSingleMeter } from 'api/subscriptions';
import { Empty, Table } from 'antd';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import { ResetButton } from '../../../components/Atom/Button';
import { useParams } from 'react-router-dom';
import LoadingSkeleton from '../../../components/Skeleton/index';
import StatusTag from 'components/Atom/StatusTag';
import '../../Subscriptions/style.css';

export const ViewMeterDetails = () => {
  const [record, setRecord] = useState(null);
  const location = useLocation();
  const store = useSelector((state) => state.company.store);
  const { id } = useParams();
  const navigate = useNavigate();

  const fetchMeterData = async () => {
    const response = await getSingleMeter(store?._id, id || location?.state?.record?.id);
    return response?.data?.data || null;
  };

  const { data, refetch, isLoading, isFetching } = useQuery(`meter_${id || location?.state?.record?.id}`, fetchMeterData, {
    enabled: false,
    manual: true,
  });

  useEffect(() => {
    refetch();
  }, [store]);

  useEffect(() => {
    if (data) setRecord(data);
  }, [data]);

  const breadcrumbProps = {
    breadcrumbs: [
      {
        name: 'XPay',
        href: '/xpay',
      },
      {
        name: 'Meter',
        href: '/billing-engine/meter',
        data: { id: location?.state?.id, isRedirection: true, filtersData: location?.state?.filtersData, searchValue: location?.state?.searchValue },
      },
      {
        name: <ShortenId value={id || location?.state?.id || 'Not Found'} />,
      },
    ],
  };

  const formatAdditionalType = (type) => {
    if (!type) return 'N/A';
    return type?.charAt(0)?.toUpperCase() + type?.slice(1);
  };

  const additionalColumns = [
    {
      title: 'Key',
      dataIndex: 'key',
      key: 'key',
      render: (value) => value || 'N/A',
    },
    {
      title: 'Value',
      dataIndex: 'value',
      key: 'value',
      render: (value) => (value !== undefined && value !== null ? value : 'N/A'),
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      render: (value) => formatAdditionalType(value),
    },
    {
      title: 'Inclusive',
      dataIndex: 'inclusive',
      key: 'inclusive',
      render: (value) => (value === true ? 'Yes' : 'No'),
    },
  ];

  const time_zone = store?.settings?.timezone || TIMEZONES.PKT;
  const generalInformation = [
    { label: 'Meter ID', value: <ShortenId value={record?.id} /> },
    { label: 'Name', value: record?.name },
    { label: 'Aggregation Type', value: record?.aggregation_type },
    { label: 'Aggregation Field', value: record?.aggregation_field },
    { label: 'Status', value: <StatusTag tag={record?.active === true ? 'active' : 'inactive'} /> },
    { label: 'Creation Time', value: record?.createdAt ? formatInTimeZone(record?.createdAt, time_zone, 'MMM d, yyyy h:mm:ss a') : '-' },
    { label: 'Last Update Time', value: record?.updatedAt ? formatInTimeZone(record?.updatedAt, time_zone, 'MMM d, yyyy h:mm:ss a') : '-' },
  ];

  return (
    <>
      <div className='header-container p-4 custom-sticky'>
        <div className='payment-breadcrums'>
          <div
            className='back-button'
            onClick={() =>
              navigate('/billing-engine/meter', {
                state: {
                  id: location?.state?.id,
                  isRedirection: true,
                  filtersData: location?.state?.filtersData,
                  searchValue: location?.state?.searchValue,
                },
              })
            }>
            <ArrowLeftOutlined /> <span style={{ fontWeight: 600 }}>Back</span>
          </div>
          <span style={{ color: '#8C8C8C' }}>|</span>
          <Breadcrumbs {...breadcrumbProps} />
          <ResetButton onClick={refetch} loading={isFetching} />
        </div>
        <div className='detail-heading mb-0 mt-4'>Meter Detail</div>
      </div>
      <div className='subscription-details logs-details'>
        {isLoading ? (
          <LoadingSkeleton />
        ) : !record ? (
          store?.isSelected ? (
            <div className='empty-custom-style'>
              <Empty image={Empty?.PRESENTED_IMAGE_SIMPLE} />
            </div>
          ) : (
            <div className='empty-custom-style'>
              <Empty description={'Select store from the drop-down menu above'} />
            </div>
          )
        ) : (
          <>
            <div className='details-section '>
              <div className='heading-section'>
                <h3>Meter Detail</h3>
              </div>
              <div className='detail-card'>
                {generalInformation?.map((info, index) => (
                  <div key={index} className='detail-value'>
                    <h2>{info?.label}</h2> <span>{info?.value || 'N/A'}</span>
                  </div>
                ))}
              </div>
            </div>

            {record?.taxes?.length > 0 && (
              <div className='details-section'>
                <div className='heading-section'>
                  <h3>Tax Charges</h3>
                </div>
                <div className='table-container'>
                  <Table columns={additionalColumns} dataSource={record?.taxes} pagination={false} rowKey={(row, index) => row?.key || index} />
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default ViewMeterDetails;
